import { render, staticRenderFns } from "./announcementchannel.vue?vue&type=template&id=5a31997b&scoped=true&"
import script from "./announcementchannel.vue?vue&type=script&lang=js&"
export * from "./announcementchannel.vue?vue&type=script&lang=js&"
import style0 from "./announcementchannel.vue?vue&type=style&index=0&id=5a31997b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a31997b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a31997b')) {
      api.createRecord('5a31997b', component.options)
    } else {
      api.reload('5a31997b', component.options)
    }
    module.hot.accept("./announcementchannel.vue?vue&type=template&id=5a31997b&scoped=true&", function () {
      api.rerender('5a31997b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/announcement/announcementchannel.vue"
export default component.exports